<template>
    <div class="app">
        <AppHeader />
        <div class="app-body">
            <AppSidebar />
            <main class="main">
                <!--<breadcrumb :list="list"/>-->
                <!-- <b-breadcrumb :items="list" /> -->
                <div class="container-fluid" style="margin-top: 10px">
                    <router-view :key="$router.currentRoute.fullPath" />
                </div>
            </main>
            <!-- <AppAside fixed>
                <DefaultAside />
            </AppAside>-->
        </div>

        <ChatWidget />
        <AppFooter>
            <!-- Footer -->
        </AppFooter>
        <!-- Notification center -->
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import AppSidebar from './Sidebar'

import AppHeader from './AppHeader'

// import DefaultAside from './DefaultAside'
import AppFooter from './AppFooter'
import { humanize } from 'inflected'

import i18n from '@/locales'
import ChatWidget from '@/components/ChatWidgetComponent'

import { mapGetters } from 'vuex'

export default {
    name: 'full',
    components: {
        // AsideToggler,
        AppHeader,
        AppSidebar,
        // AppAside,
        AppFooter,
        // DefaultAside,
        // SidebarForm,
        // SidebarFooter,
        // SidebarToggler,
        // SidebarHeader,
        // SidebarNav,
        // SidebarMinimizer,
        ChatWidget,
    },
    props: {},
    // data() {
    //     return {}
    // },
    onActive() {
        this.$store.dispatch('auth/getTimeLeftOnToken').then(res => {
            let timeoleftOnToken = Math.abs(res)
            if (timeoleftOnToken > 0)
                this.$store.dispatch('auth/refreshToken').then(() => {
                    this.$snotify.remove('session.expire-warning')
                })
        })
    },

    created() {},

    methods: {
        registerEvents() {},
    },

    computed: {
        ...mapGetters(['']),
        name() {
            return this.$route.name
        },
        list() {
            return this.$route.matched.map(route => {
                if (route.name) {
                    let translatedName = i18n.t('label.'.concat(route.name))
                    let humanizedName = humanize(translatedName)
                    return {
                        text: humanizedName,
                        name: humanizedName,
                    }
                }
            })
        },
        transladedNav() {
            return this.orgNavItems.map(function(item) {
                item.name = i18n.t(item.trans_fullname)
                return item
            })
        },
    },
}
</script>
<style lang="scss" scoped>
// @include media-breakpoint-up(sm) { ... }

@media (max-width: 768px) {
    .main .container-fluid {
        padding-left: 0;
        padding-right: 0;
    }
}
// @include media-breakpoint-up(lg) { ... }
// @include media-breakpoint-up(xl) { ... }
</style>
